<template>
  <div class="notification-page">
    <header-pane
      class="notification-page__header"
      colorType="light"
      :pageTitle="$tc('NotificationPage.pageTitle')"
      current="notification"
      navigationCurrent="notification"
    />

    <notification-pane />

    <global-navigation-pane current="notification" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import HeaderPane from '@/components/common/Header/HeaderPane.vue'
import GlobalNavigationPane from '@/components/common/GlobalNavigation/GlobalNavigationPane.vue'
import NotificationPane from '@/components/NotificationPane/NotificationPane.vue'

/**
 * NOTIFICATION 通知ページ
 */
export default defineComponent({
  name: 'NotificationPage',
  components: {
    HeaderPane,
    GlobalNavigationPane,
    NotificationPane,
  },
})
</script>

<style lang="scss" scoped>
.notification-page {
  background: $gray1;
  min-height: var(--screen-height);
  padding-bottom: env(safe-area-inset-bottom);
}
</style>
